"use strict";

exports.__esModule = true;
exports.OraclePriceProvider = void 0;
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _sdkCore = require("@acala-network/sdk-core");
var _storage = require("../../utils/storage");
var _getLiquidCrowdloanTokenPrice = require("../utils/get-liquid-crowdloan-token-price");
const DEFAULT_ORACLE_STRATEGIES = {
  // taiKSM has renamed to tKSM
  taiKSM: ['AS', 'KSM'],
  tKSM: ['AS', 'KSM'],
  tDOT: ['AS', 'DOT'],
  lcDOT: ['LIQUID_CROWDLOAN', 13]
};
class OraclePriceProvider {
  constructor(api, config) {
    this.api = void 0;
    this.stakingToken = void 0;
    this.strategies = void 0;
    this.tokenProvider = void 0;
    this.api = api;
    this.stakingToken = config.stakingToken;
    this.tokenProvider = config.tokenPrivoder;
    this.strategies = (config === null || config === void 0 ? void 0 : config.strategies) || DEFAULT_ORACLE_STRATEGIES;
  }
  queryFormOracle(token) {
    const storage$ = _storage.Storage.create({
      api: this.api,
      path: 'query.acalaOracle.values',
      params: [token.toChainData()]
    }).observable;
    return storage$.pipe((0, _operators.map)(value => {
      const price = value.isEmpty ? '0' : value.value.value.toString();
      return _sdkCore.FixedPointNumber.fromInner(price, 18);
    }));
  }
  subscribe(token) {
    const strategies = this.strategies;
    if (!strategies) return (0, _rxjs.of)(_sdkCore.FixedPointNumber.ZERO);
    const symbol = token.symbol;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const [strategy, addon] = strategies[symbol] || ['STORAGE', ''];
    if (strategy === 'AS') {
      return this.subscribe(this.tokenProvider.getToken(addon));
    }
    if (strategy === 'LIQUID_CROWDLOAN') {
      return this.subscribe(this.stakingToken).pipe((0, _operators.switchMap)(price => {
        return (0, _getLiquidCrowdloanTokenPrice.subscribeLiquidCrowdloanTokenPrice)(this.api, price, addon);
      }));
    }
    return this.queryFormOracle(token);
  }
  async query(currency) {
    return (0, _rxjs.firstValueFrom)(this.subscribe(currency));
  }
  queryFeedTokens() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.api.query.acalaOracle.values.keys().pipe((0, _operators.map)(data => {
      return data.map(i => i.args[0]);
    }));
  }
  queryRawData(token) {
    const storage$ = _storage.Storage.create({
      api: this.api,
      path: 'query.acalaOracle.values',
      params: [token.toChainData()]
    }).observable;
    return storage$.pipe((0, _operators.map)(value => {
      const price = value.isEmpty ? '0' : value.value.value.toString();
      const timestamp = value.isEmpty ? '0' : value.value.timestamp.toString();
      return {
        token,
        timestamp,
        price: _sdkCore.FixedPointNumber.fromInner(price, 18)
      };
    }));
  }
}
exports.OraclePriceProvider = OraclePriceProvider;